export const environmentNames = Object.freeze({
  DEV: "cdt-dev",
  EDU: "cdt-edu",
  TEST: "cdt-test",
  PREPROD: "preprod",
  PROD: "prod",
});